if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        document.body.style.pointerEvents = 'none';
        const buyNowButton = document.querySelector('.custom-buy-now');
        if (buyNowButton) {
          buyNowButton.disabled = true;    
          buyNowButton.style.pointerEvents = 'none'; 
          buyNowButton.style.cursor = 'not-allowed';         
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const custombutton = evt.submitter || evt.target.closest('button');

        // const mainProductId = custombutton?.dataset.mainProduct;
        // const freebieProductId = custombutton?.dataset.freebieProduct;

        const mainEligibleProduct = custombutton?.dataset.mainEligibleProduct;

        // const onamMainProduct = custombutton?.dataset.onammainProduct;
        // const onamFreebieProductId = custombutton?.dataset.onamfreebieProduct;
        // const onamAddMainProduct = custombutton?.dataset.freeproductAdd;

        const formData = new FormData(this.form);
        
        // if (onamMainProduct && onamFreebieProductId && onamAddMainProduct) { 
        //     formData.append('properties[_onam_free_gift]', onamMainProduct);
        //     formData.append('properties[_onam_free_gift_product]', onamFreebieProductId);
        //     formData.append('properties[_onam_add_free_product]', onamAddMainProduct);
        // }

        // if (mainProductId && freebieProductId) {
        //     formData.append('properties[_main_product]', mainProductId);
        //     formData.append('properties[_free_gift_product]', freebieProductId);
        // }

        // if(mainEligibleProduct){
          formData.append('properties[_main_eligible_product]', mainEligibleProduct);
        // }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;        

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            if (response.message && typeof window.setCartLineQuantityError === 'function') {
              const lineIndex = response.items?.findIndex(
                (item) => String(item.variant_id) === String(formData.get('id'))
              );
              if (lineIndex >= 0) {
                window.setCartLineQuantityError(lineIndex + 1, response.message);
              }
            }
            try {
              if (window.COUPON_SETTINGS?.enabled && typeof window.syncCouponBannerFromDOM === 'function') {
                window.syncCouponBannerFromDOM();
              }
            } catch (e) {}
            try {
              if (window.COUPON_SETTINGS?.enabled && typeof window.checkAndUpdateCouponState === 'function') {
                window.checkAndUpdateCouponState();
              }
            } catch (e) {
              console.error('Coupon state refresh error:', e);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
             document.body.style.pointerEvents = 'unset';  

            //  Body pointer events is set to unset
          
               fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
              
               if(document.querySelector('#CartDrawer')) { 
                 document.querySelector('#CartDrawer').innerHTML =
              html.documentElement.querySelector('#CartDrawer').innerHTML;}

                if(document.querySelector('.header__icon--cart .cart-count-bubble span')){
                   document.querySelector('.header__icon--cart .cart-count-bubble span').innerHTML =
              html.documentElement.querySelector('.cart-count-bubble span').innerHTML;
                }
                else{
                  document.querySelector('.header__icon--cart').innerHTML += `<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true"></span>  </div>`
                     document.querySelector('.header__icon--cart .cart-count-bubble span').innerHTML =
              html.documentElement.querySelector('.cart-count-bubble span').innerHTML;
                }
               
               // Ensure Diwali free gift message updates after DOM replacement
               try {
                 if (typeof window.isFreeGiftConfigured === 'function' && window.isFreeGiftConfigured() && typeof window.updateFreeGift === 'function') {
                   window.updateFreeGift();
                 }
               } catch (e) {
                 console.error('Diwali message update error:', e);
               }

               try {
                if (window.COUPON_SETTINGS?.enabled && typeof window.syncCouponBannerFromDOM === 'function') {
                  window.syncCouponBannerFromDOM();
                }
              } catch (e) {}
            
              try {
                if (window.COUPON_SETTINGS?.enabled && typeof window.checkAndUpdateCouponState === 'function') {
                  window.checkAndUpdateCouponState();
                }
              } catch (e) {
                console.error('Coupon state refresh error:', e);
              }
                
              })
              .catch((e) => {
                console.error(e);
              });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
        
      }
    }
  );
}
